"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = exports.default = void 0;
var _react = require("react");
var _css = require("@emotion/css");
var _hooks = require("../../hooks");
var _CetComponentsProvider = require("../../providers/CetComponentsProvider");
const useStyles = chipProps => {
  const {
    fontFamily,
    themeColors
  } = (0, _react.useContext)(_CetComponentsProvider.CetComponentsContext);
  const {
    color = 'primary',
    size = 'medium',
    isSelected,
    isDisabled,
    icon
  } = chipProps;
  const {
    pxToRem,
    fontSizeProps,
    getElementHeight
  } = (0, _hooks.useStylesUtils)();
  const ccChipStyle = (0, _react.useMemo)(() => {
    const iconProps = () => {
      const margin = icon ? `${pxToRem(4)} ${pxToRem(10)}` : `${pxToRem(4)} ${pxToRem(5)}`;
      return {
        margin
      };
    };
    const firstIconProps = () => {
      if (!icon) {
        return {
          marginInlineStart: 0
        };
      }
      return {};
    };
    const colorProps = () => {
      const textColor = color === 'primary' ? themeColors?.primary.main : themeColors?.general.text;
      return {
        color: textColor
      };
    };
    const selectedProps = isSelected => {
      return isSelected ? {
        border: `1px solid ${themeColors?.primary?.main}`,
        backgroundColor: themeColors?.primary.light,
        boxShadow: `0 ${pxToRem(5)} ${pxToRem(9)} ${themeColors?.primary.shadow}`
      } : {};
    };
    const hoverProps = isHover => {
      return isHover ? {
        '&:hover': {
          ...selectedProps(isHover)
        }
      } : {};
    };
    const disabledProps = () => {
      return isDisabled ? {
        opacity: 0.5,
        cursor: 'default'
      } : {};
    };
    const sizeProps = () => {
      const height = getElementHeight(size);
      let padding;
      switch (size) {
        case 'small':
          padding = `0 ${pxToRem(16)}`;
          break;
        case 'medium':
          padding = `0 ${pxToRem(18)}`;
          break;
        case 'large':
          padding = `0 ${pxToRem(20)}`;
          break;
      }
      return {
        height,
        padding
      };
    };
    const iconSizeProps = () => {
      let iconSize;
      switch (size) {
        case 'small':
          iconSize = 14;
          break;
        case 'medium':
          iconSize = 16;
          break;
        case 'large':
          iconSize = 20;
          break;
      }
      return {
        lineHeight: pxToRem(iconSize),
        svg: {
          width: pxToRem(iconSize * 0.65),
          height: pxToRem(iconSize * 0.65)
        }
      };
    };
    const iconColorProps = () => {
      const backgroundColor = color === 'primary' ? themeColors?.primary.main : themeColors?.basic.dark;
      return {
        backgroundColor
      };
    };
    const ccChip = (0, _css.css)({
      fontFamily: fontFamily,
      backgroundColor: themeColors?.general.light,
      position: 'relative',
      border: `1px solid ${themeColors?.general.border}`,
      borderRadius: pxToRem(25),
      justifyContent: 'center',
      alignItems: 'center',
      whiteSpace: 'nowrap',
      display: 'inline-flex',
      cursor: chipProps.onClick ? 'pointer' : 'default',
      ...sizeProps(),
      ...colorProps(),
      ...iconProps(),
      ...fontSizeProps(size),
      ...selectedProps(Boolean(color === 'primary' && isSelected)),
      ...hoverProps(Boolean(color === 'primary')),
      ...disabledProps(),
      '&:first-child': {
        ...firstIconProps()
      }
    });
    const ccChipIcon = (0, _css.css)({
      position: 'absolute',
      display: 'flex',
      stroke: 'none',
      fill: themeColors?.general.light,
      top: '50%',
      left: '100%',
      padding: pxToRem(3),
      borderRadius: '50%',
      transform: 'translate(-50%, -50%)',
      cursor: chipProps.onClick || chipProps.onIconClick ? 'pointer' : 'default',
      ...iconColorProps(),
      ...iconSizeProps()
    });
    return {
      ccChip,
      ccChipIcon
    };
  }, [chipProps.onClick, chipProps.onIconClick, color, fontFamily, fontSizeProps, getElementHeight, icon, isDisabled, isSelected, pxToRem, size, themeColors?.basic.dark, themeColors?.general.border, themeColors?.general.light, themeColors?.general.text, themeColors?.primary.light, themeColors?.primary.main, themeColors?.primary.shadow]);
  return {
    'cc-Chip': ccChipStyle.ccChip,
    'cc-Chip__icon': ccChipStyle.ccChipIcon
  };
};
exports.useStyles = useStyles;
var _default = exports.default = useStyles;